/**
 * @generated SignedSource<<26a7b7da0a490242f5be435b004e4098>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ZapierIntegrationQuery$variables = {};
export type ZapierIntegrationQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly hasAccessToZapierIntegration: boolean;
      };
    };
    readonly integrations: {
      readonly zapier: {
        readonly isConnected: boolean;
      } | null;
    };
  };
};
export type ZapierIntegrationQuery = {
  response: ZapierIntegrationQuery$data;
  variables: ZapierIntegrationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "hasAccessToZapierIntegration",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "zapier_integration"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"zapier_integration\")"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ZapierIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZapierUserNode",
                "kind": "LinkedField",
                "name": "zapier",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ZapierIntegrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZapierUserNode",
                "kind": "LinkedField",
                "name": "zapier",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3729d8be93ea81a526dc6a199199c67e",
    "id": null,
    "metadata": {},
    "name": "ZapierIntegrationQuery",
    "operationKind": "query",
    "text": "query ZapierIntegrationQuery {\n  viewer {\n    account {\n      billingAccount {\n        hasAccessToZapierIntegration: hasAccessToFeature(feature: zapier_integration)\n        id\n      }\n      id\n    }\n    integrations {\n      zapier {\n        isConnected\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "da82a8503786d3e9925ef2f69fac8941";

export default node;
